import { View } from "react-native";
import { colors } from "../../theme";
import { Text } from "react-native-paper";

const NotificationBanner = ({
  IconComp,
  text,
  textColor,
  iconColor,
  borderColor = "border-blue-light",
  backgroundColor = colors.blue.lightest,
}: {
  IconComp: React.ComponentType<{ color: string; size: number }>;
  text: string;
  textColor: string;
  iconColor: string;
  borderColor?: string;
  backgroundColor?: string;
}) => {
  return (
    <View
      testID="notification-banner"
      className={`mt-4 mb-8 md:mb-0 border p-3 rounded-lg ${borderColor}`}
      style={{ backgroundColor }}
    >
      <View className="flex-row items-center">
        <IconComp color={iconColor} size={24} />
        <Text className={`text-small-tight ${textColor} ml-4`}>{text}</Text>
      </View>
    </View>
  );
};

export default NotificationBanner;
